module.exports = __webpack_public_path__ + "img/i_left.f3026d18.svg";